import {
  transformConditionsFromBackend,
  transformConditionsToBackend,
} from '@/common/components/ConditionsEditor/helpers'
import { booleanFields } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/AvailabilityCriterionDetailConfiguration/constants'

export const transformResponseGetAvailabilityCriterion = criterion => ({
  id: criterion.id,
  internal_id: criterion.internal_id,
  name: criterion.name,
  description: criterion.description,
  conditions: transformConditionsFromBackend(criterion.conditions || [], { booleanFields }),
  delivery_method_ids: criterion.delivery_method_ids || [],
})

export const transformRequestCreateAvailabilityCriterion = ({ storeId, criterion, defaultCurrency }) => ({
  storeId,
  criterion: {
    name: criterion.name,
    description: criterion.description,
    conditions: transformConditionsToBackend(criterion.conditions || [], { defaultCurrency }),
  },
})

export const transformRequestEditAvailabilityCriterion = ({ storeId, criterionId, criterion, defaultCurrency }) => ({
  storeId,
  criterionId,
  criterion: {
    name: criterion.name,
    description: criterion.description,
    conditions: transformConditionsToBackend(criterion.conditions || [], { defaultCurrency }),
  },
})
